import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {AdminService} from '../../../services/admin.service';
import {UserService} from '../../../services/user.service';
import * as moment from 'moment';
import {StepsControllerService} from '../../../services/steps-controller.service';
import {MessageService} from '../chat/message.service';
import {ApiConnectService} from '../../../services/api-connect.service';
import {NotificationsService} from '../../../services/notifications.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ViewDocxService} from '../../../services/view-docx.service';
import {ViewDocxComponent} from '../../views/view-docx/view-docx.component';

@Component({
  selector: 'app-user-confirm-standard',
  templateUrl: './user-confirm-standard.component.html',
  styleUrls: ['./user-confirm-standard.component.css']
})
export class UserConfirmStandardComponent implements OnInit, OnDestroy {
  isLoaded = false;
  public standardId: string;
  standard: any;
  stringDate: string;
  nextTwoBtn = false; // familiarizationDate
  nextModificationBtn = false;
  nextApprovedBtn = false;
  errorMessage = false;

  authorIsHere = false;

  constructor(private route: ActivatedRoute,
              private http: HttpClient,
              private router: Router,
              public viewDocxService: ViewDocxService,
              private modalService: NgbModal,
              private adminService: AdminService,
              private userService: UserService,
              private notificationsService: NotificationsService,
              private apiConnectService: ApiConnectService,
              public stepsControllerService: StepsControllerService,
              private messageService: MessageService) {
  }

  ngOnDestroy() {
    this.stepsControllerService.setLogsID(null);
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.standardId = params['id'];
      this.isLoaded = false;
      this.getSyabdard();
    });
    this.isLoaded = false;
    this.getSyabdard();
  }


  openDocModal(docxID, sID) {
    localStorage.setItem('DocxID', docxID);
    localStorage.setItem('DocxSID', sID);

    const modalRef = this.modalService.open(ViewDocxComponent, {size: 'lg', backdrop: 'static'});
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxID();
      }
    }, (reason) => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxID();
    });

  }


  openDocModalDOCX(fileLink) {
    localStorage.setItem('fileLink', fileLink);

    const modalRef = this.modalService.open(ViewDocxComponent, {size: 'lg', backdrop: 'static'});
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxIDManually();
      }
    }, (reason) => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxIDManually();
    });

  }


  getSyabdard() {
    this.nextTwoBtn = false;
    this.nextModificationBtn = false;
    this.nextApprovedBtn = false;
    this.authorIsHere = false;

    // Data
    this.stringDate = moment().format('DD.MM.YYYY');
    this.standardId = this.route.snapshot.params['id'];
    this.stepsControllerService.setLogsID(this.standardId);

    // get standard;
    this.adminService.getStandard(this.standardId).subscribe(
      (response: any) => {
        this.errorMessage = false;
        if (response.status === 200) {
          this.standard = response.body;

          if (this.router.url.includes('ex-notification-confirm-action/')) {
            this.stepsControllerService.setCurrentStandard(this.standard);
          }

          this.messageService.setTempStandard(this.standard);

          // Get confirmation info:
          this.stepsControllerService.getConfirmatoriesInfo(this.standardId).subscribe(
            (res: any) => {
              this.errorMessage = false;
              if (res.status === 200) {
                const tableUsers = res.body;
                let tempMe: any;

                for (const item of tableUsers) {
                  if (item.user.id === this.userService.getLocal().id) {
                    tempMe = item;
                    break;
                  }
                }

                if (tempMe !== undefined) {
                  if (tempMe.acknowledgementDate !== '') {
                    this.nextTwoBtn = true;
                  }
                  if (tempMe.modificationRequestDate !== '') {
                    this.nextModificationBtn = true;
                    this.nextApprovedBtn = false;
                  }
                  if (tempMe.confirmationDate !== '') {
                    this.nextModificationBtn = false;
                    this.nextApprovedBtn = true;
                  }
                } else {
                  this.authorIsHere = true;
                }
                this.isLoaded = true;
              }
            },
            () => {
              this.errorMessage = true;
              this.isLoaded = true;
            }
          );
        }
      },
      () => {
        this.isLoaded = true;
        this.errorMessage = true;
      });
  }

  openPdfStnd(fileId: string) {
    window.open(this.apiConnectService.getPdf + fileId, '_blank');
  }

  downloadFile(id) {
    this.isLoaded = false;
    this.userService.getFile(id).subscribe(
      (response: any) => {
        this.errorMessage = false;
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.body);
        link.download = response.headers.get('filename');
        link.click();
        link.remove();
      },
      () => {
      }, () => {
        this.errorMessage = true;
        this.isLoaded = true;
      }
    );

  }

  familiarizeWithStandard() {
    this.userService.doAcknowledgeWithStandard(this.standard.id).subscribe(
      (response: any) => {
        this.errorMessage = false;
        this.nextTwoBtn = true;
      },
      () => {
        this.errorMessage = true;
      }
    );
  }

  approved() {
    this.userService.doApproved(this.standard.id).subscribe(
      (response: any) => {
        this.errorMessage = false;
        this.nextModificationBtn = false;
        this.nextApprovedBtn = true;

        this.notificationsService.getNearNotificationFromAPI();
        // ex-notification-confirm-action
        this.goToExNotifList();

      },
      () => {
        this.errorMessage = true;
      }
    );
  }

  requiresModification() {
    this.userService.doRequiresModification(this.standard.id).subscribe(
      (response: any) => {
        this.errorMessage = false;
        this.nextModificationBtn = true;
        this.nextApprovedBtn = false;

        this.notificationsService.getNearNotificationFromAPI();
        // ex-notification-confirm-action
        this.goToExNotifList();

      },
      () => {
        this.errorMessage = true;
      }
    );
  }

  goToExNotifList() {
    if (this.router.url.includes('ex-notification-confirm-action/')) {
      this.router.navigate(['/ex-notifications']);
    }
  }

}




// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/operating-standard/user-confirm-standard/user-confirm-standard.component.ts